<template>
	<joy-page :joyPageStatus="joyPageStatus">
		<div class="setHeightFullGrey">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<van-cell title="图片上传"></van-cell>
				<div class="paddingXm">
					<van-uploader  v-model="imgList2" :before-read="beforeRead"  @delete="deleteImg" multiple  />
				</div>
		</van-pull-refresh>
		
		</div>
	</joy-page>
</template>

<script>
	import { Toast } from 'vant';
	var loadImg;
	export default{
		data(){
			return{
				joyPageStatus:'',
				isLoading: false,
				imgList:[],
				imgList2:[],
				flag:0,
				
			}
		},
		watch:{
		},
		methods:{
			beforeRead(file){
				const that=this;
			    Toast.loading({
				  duration: 0,       // 持续展示 toast
				  forbidClick: true, // 禁用背景点击
				  loadingType: 'spinner',
				  mask:true,
				  message: '图片上传中',
				});
				if(file.length>1){
					for(let i in file) {
					 	this.baseImg(file[i],file.length);
					};
				}else{
					console.log('进来了胆颤上传')
					let reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onloadend = function () {
						console.log('this.result进来了',this.result)
						that.$lrz(this.result,{width:that.$mConfig.width,quality:that.$mConfig.quality}).then(function (rst) {
							 that.uploadPic(rst.base64,1);
						})
					};
				}
				
				return false;
			},
		    baseImg(file,fileLength){
				const that=this;
				let reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onloadend = function () {
					//console.log(this.result);
					that.$lrz(this.result,{width:that.$mConfig.width,quality:that.$mConfig.quality}).then(function (rst) {
						 that.uploadPic(rst.base64,fileLength);
					})
				};
			},
			// 修改异常里面的上传图片到阿里云
			 uploadPic(base64,fileLength){
				const that=this;
				try{
					that.$axios.post('childrenpic/create',{file:base64,"children_id":this.children_id}).then(res => {
						if(res.data.code==200){
							 that.flag++;
							 console.log('数据是',that.flag,fileLength);
							 if(that.flag=== fileLength){
								that.flag=0;
								Toast.clear();
								setTimeout(function() {
									that.$toast.success('上传成功')
								}, 500);
							 }
							let modeImg=res.data.data.image;
							that.imgList2.push({url:modeImg,id:res.data.data.id});
							}else{
							  that.$toast.fail(res.data.msg)
							  return false;
							}
					})
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
					
							
			},
			deleteImg(e){
				console.log(e);
				const that=this;
				try{
					that.$axios.delete('childrenpic/delete?id='+e.id).then(res => {
						if(res.data.code==200){
							that.$toast.success('删除成功')
							}else{
							  that.$toast.fail(res.data.msg)
							  return false;
							}
					})
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			},
			loadImg(){
				this.joyPageStatus = 'loading';
				let query={
					children_id:this.children_id,
					camp_id:this.camp_id
				};
				try{
					this.$axios.get('childrenpic/list?children_id='+this.children_id+'&camp_id='+this.camp_id).then(res => {
						this.joyPageStatus = 'success';
						if (res.data.code == 200) {
							this.imgList=res.data.data;
							for(let i in res.data.data) {
								res.data.data[i].pic='http://img.jiarixiaodui.com/'+res.data.data[i].pic;
								 this.imgList2.push({url:res.data.data[i].pic,id:res.data.data[i].id,content:res.data.data[i].pic});
							};
								console.log(res.data.data)
						};
					}).catch(function (error) {
					  this.joyPageStatus = 'fail';
					});
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				};
			},
			onRefresh() {
				setTimeout(() => {
					this.isLoading = false;
					this.reload();
					this.$toast('刷新成功');
				}, 1000);
			},
			reload(){
				this.reportList=[];
				this.loadReport();
			},
		},
		created() {
			this.children_id=this.$route.query.children_id; 
			this.camp_id=this.$route.query.camp_id;
			this.loadImg();
		},
	}
	
</script>

<style>
</style>
